module.exports = __webpack_public_path__ + "img/TAC6000_1-1.15ebf2ef.png";